<template>
    <li v-if="messagesTotal">
        <b-alert show variant="primary" class="lx-header-messages-alert text-nowrap text-center">
            <h6>Notifications</h6>
            You have
            <span v-if="messagesTotal"
                ><strong>{{ messagesTotal }}</strong> unread message{{ messagesPlural }}</span
            >
        </b-alert>
        <div>
            <b-list-group flush v-if="notificationsCount">
                <header-message
                    v-for="(item, index) in notifications"
                    :key="'hmn' + index"
                    :message="item"
                    on-dismiss-action="header/dismissNotification"
                ></header-message>
            </b-list-group>
            <b-list-group flush class="lx-header-messages" v-if="messagesCount">
                <header-message
                    v-for="(item, index) in messages"
                    :key="'hmm' + index"
                    :message="item"
                    on-dismiss-action="header/dismissMessage"
                ></header-message>
            </b-list-group>
        </div>
    </li>
</template>

<script>
    import HeaderMessage from './header-message.vue';
    import { mapGetters } from 'vuex';

    export default {
        name: 'HeaderMessages',
        components: {
            HeaderMessage,
        },
        computed: {
            ...mapGetters('header', [
                'workOrdersCount',
                'workOrdersHref',
                'failedTransactionsHref',
                'failedTransactionsCount',
                'undergoingResolutionTransactionsCount',
                'notifications',
                'notificationsCount',
                'messages',
                'messagesCount',
                'messagesTotal',
            ]),
            messagesPlural() {
                return this.messagesTotal > 1 ? 's' : '';
            },
        },
    };
</script>

<style scoped>
    .lx-header-messages-alert {
        margin-top: -0.5rem;
        margin-bottom: 0;
        background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);
        color: inherit;
    }

    .list-group-flush:first-child .list-group-item:first-child {
        border-top: 0;
    }

    .list-group-flush:last-child .list-group-item:last-child {
        margin-bottom: 0.5rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }

    .pill-btn {
        padding-top: 4.5px !important;
    }
</style>
